import { render, staticRenderFns } from "./defra-categories.vue?vue&type=template&id=b81609c8&scoped=true"
import script from "./defra-categories.vue?vue&type=script&lang=js"
export * from "./defra-categories.vue?vue&type=script&lang=js"
import style0 from "./defra-categories.vue?vue&type=style&index=0&id=b81609c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81609c8",
  null
  
)

export default component.exports